import React from 'react'
import { MenuItemLink, WithPermission } from 'admin-on-rest'
import { translate } from 'admin-on-rest'

const Menu = ({ hasDashboard, onMenuTap, resources, translate, logout }) => {
  if (!onMenuTap) {
    onMenuTap = () => null
  }

  return (
    <div>
      <WithPermission value="admin">
        <MenuItemLink
          to="/courses"
          primaryText={translate('courses.list.title')}
          onClick={onMenuTap}
        />
      </WithPermission>
      <WithPermission value="admin">
        <MenuItemLink
          to="/courses-completed"
          primaryText={'Istoric cursuri'}
          onClick={onMenuTap}
        />
      </WithPermission>
      <WithPermission value="admin">
        <MenuItemLink
          to="/students"
          primaryText={translate('students.title')}
          onClick={onMenuTap}
        />
      </WithPermission>
      <WithPermission value="admin">
        <MenuItemLink
          to="/instructors"
          primaryText={translate('instructors.title')}
          onClick={onMenuTap}
        />
      </WithPermission>
      <WithPermission value="student">
        <MenuItemLink
          to="/credits"
          primaryText="Credite si istoric"
          onClick={onMenuTap}
        />
      </WithPermission>
      <WithPermission value="student">
        <MenuItemLink
          to="/profile"
          primaryText="Profilul meu"
          onClick={onMenuTap}
        />
      </WithPermission>
      <WithPermission value="student">
        <MenuItemLink
          to="/cursuri-in-desfasurare"
          primaryText="Cursuri in desfasurare"
          onClick={onMenuTap}
        />
      </WithPermission>
      <WithPermission value="student">
        <MenuItemLink
          to="/cursuri-inscrise"
          primaryText="Cursuri inscrise"
          onClick={onMenuTap}
        />
      </WithPermission>
      <WithPermission value="student">
        <MenuItemLink
          to="/cursuri-disponibile"
          primaryText="Cursuri disponibile"
          onClick={onMenuTap}
        />
      </WithPermission>
      <WithPermission value="instructor">
        <MenuItemLink
          to="/instructors-in-progress"
          primaryText={translate('instructors.courses.in_progress')}
          onClick={onMenuTap}
        />
      </WithPermission>
      <WithPermission value="instructor">
        <MenuItemLink
          to="/instructors-upcoming"
          primaryText={translate('instructors.courses.upcoming')}
          onClick={onMenuTap}
        />
      </WithPermission>
      <WithPermission value="instructor">
        <MenuItemLink
          to="/instructors-completed"
          primaryText={translate('instructors.courses.completed')}
          onClick={onMenuTap}
        />
      </WithPermission>
      {logout}
    </div>
  )
}

export default translate(Menu)



// WEBPACK FOOTER //
// ./src/customMenu.js